import { ReactNode } from 'react';

import { cn } from '@/app/shared/lib/cn';

export interface TabItem<T extends string | number = string | number> {
  id: T;
  content: ReactNode;
}

export interface TabsProps<T extends string | number = string | number> {
  tabs: TabItem<T>[];
  activeTab?: T;
  className?: string;
  tabClassName?: string;
  activeTabClassName?: string;
  inactiveTabClassName?: string;
  onTabChange?: (id: T) => void;
}

export function Tabs<T extends string | number = string | number>({
  tabs,
  activeTab,
  className,
  tabClassName,
  activeTabClassName,
  inactiveTabClassName,
  onTabChange,
}: TabsProps<T>) {
  return (
    <div className={className}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;

        return (
          <button
            key={tab.id}
            onClick={() => onTabChange?.(tab.id)}
            className={cn(tabClassName, isActive ? activeTabClassName : inactiveTabClassName)}
          >
            {tab.content}
          </button>
        );
      })}
    </div>
  );
}
